import { render, staticRenderFns } from "./collectionreport.vue?vue&type=template&id=1852e48a&"
import script from "./collectionreport.vue?vue&type=script&lang=js&"
export * from "./collectionreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports